import { logger } from '@nykaa/logger';
import { countriesMetaData, COUNTRY_CODE_KEY, INDIA_ISO_CODE, LOCAL_FIRST_VISIT } from 'shared/constants/internationalShipping';
import { setCookie, getCookie, deleteCookie } from 'shared/helpers/utils/cookie';
import { PIN_CODE_FOR_DELIVERY } from 'shared/constants';
import { localStorageService } from 'client/service/storage';


export const getCountriesList = () => countriesMetaData;

export const changeCountryCode = (cCode: string) => setCookie(COUNTRY_CODE_KEY, cCode, 1);

export const getSelectedCountry = () => getCookie(COUNTRY_CODE_KEY) || INDIA_ISO_CODE;

export const getSelectedCountryData = () => (
  countriesMetaData.find((country) => country.value === getSelectedCountry())
);

export const onCountryChange = (cCode: string) => {
  changeCountryCode(cCode);
  deleteCookie(PIN_CODE_FOR_DELIVERY);
  location.reload();
};

export const isIndiaSelected = () => {
  try {
    return getSelectedCountry() === INDIA_ISO_CODE;
  }
  catch (e) {
    logger.error(e, 'Checking Selected Country');
    return true;
  }
};

export const isFirstVisit = () => {
  if (!localStorageService.getItem(LOCAL_FIRST_VISIT)) {
    return true;
  }
  return false;
};

export const setVisited = (val = false) => {
  localStorageService.setItem(LOCAL_FIRST_VISIT, val);
};
